import { fileTagsState } from './fileTagsSlice';

export const initialState: fileTagsState = {
  loading: 'idle',
  data: [],
};
